import { Navigate, Route, Routes } from 'react-router';
import { ForgotPassword } from './pages/forgot-password';
import { Register } from './pages/register';
import { ResetPassword } from './pages/reset-password';
import { SsoCallback } from './pages/sso';
import { TicketRegister } from './pages/ticket-register';
import LoginPage from './pages/login';
import { getAuthToken } from '@/utils/auth-token';

export const AuthRoutes = () => {
  const token = getAuthToken();

  if (token) return <Navigate to="/" replace />;

  return (
    <Routes>
      <Route index element={<LoginPage />} />
      <Route path="esqueci-minha-senha" element={<ForgotPassword />} />
      <Route path="trocarsenha" element={<ResetPassword />} />
      <Route path="registrar" element={<Register />} />
      <Route path="novos_registros" element={<TicketRegister />} />
      <Route path="sso" element={<SsoCallback />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
};
